import { render, staticRenderFns } from "./HomeDocumentation.vue?vue&type=template&id=506f70be&scoped=true&"
import script from "./HomeDocumentation.vue?vue&type=script&lang=js&"
export * from "./HomeDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./HomeDocumentation.vue?vue&type=style&index=0&id=506f70be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f70be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSheet,VSimpleTable})
